import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class SignalStrengthCalculatorService {
	map: Record<string, number[]> = {
		"100": [-1, -31],
		"95": [-32, -37],
		"90": [-38, -43],
		"85": [-44, -48],
		"80": [-49, -52],
		"75": [-53, -56],
		"70": [-57, -60],
		"65": [-61, -63],
		"60": [-64, -66],
		"55": [-67, -69],
		"50": [-70, -72],
		"45": [-73, -74],
		"40": [-75, -77],
		"35": [-78, -79],
		"30": [-80, -82],
		"25": [-83, -84],
		"20": [-85, -86],
		"15": [-87, -88],
		"10": [-89, -91],
		"5": [-92, -93],
		"1": [-94, -100],
		"0": [-101, -140],
	};

	GetSignalPercentage(strength: number): number {
		for (const key in this.map) {
			// console.log(strength)
			if (strength <= this.map[key][0] && strength >= this.map[key][1]) {
				// console.log(strength);
				return parseInt(key);
			}
		}
		return -1;
	}
}
